
import { MDBAlert, MDBBtn, MDBCard, MDBCardBody, MDBCol,  MDBRow } from 'mdbreact';
import React from 'react';
import {  Redirect } from 'react-router-dom';
import vi_logo from '../../Assets/visaero_logo.png';
import vd_logo from '../../Assets/visadone_logo.png';
import styles from './VerifyOtp.module.css';
import axios from '../../authAxios'
// import TextField from '@material-ui/core/TextField';
import OtpInput from "react-otp-input";


// const brand_color = localStorage.getItem("brand_color")
export class VerifyOtp extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            brand_color :"",
            hidden: true,
            second_focus: "autoFocus",
            user_id: '',
            mobile_no: '',
            country_code: '',
            isOTPVerified: false,
            number: '',
            isComingFrom: '',
            logo: '',
            error : false,
            errorMsg : "",
            success : false,
            successMsg : ""
        }
        this.handleOTPChange = this.handleOTPChange.bind(this)
    }
    componentDidMount() {
        this.setState({brand_color : localStorage.getItem('brand_color')})
        const host = localStorage.getItem('host');
        if (host == "visaero") {
            this.setState({ logo: vi_logo })
        } else if (host == "visadone") {
            this.setState({ logo: vd_logo })
        }
        // console.log("verify local storage userid")
        // console.log(localStorage.getItem("user_id"))
        this.setState({
            user_id: localStorage.getItem("user_id"),
            mobile_no: localStorage.getItem("mobile_no"),
            country_code: localStorage.getItem("country_code"),
            isComingFrom: localStorage.getItem("coming_from"),
        });
    }
    resendOtp = () => {
        this.api_ResendOTP();
    }

    toggleShow = () => {
        this.setState({ hidden: !this.state.hidden });
    }

    handlePassword = (e) => {
        // console.log(e.target.value)
    }

    handleOTPChange(e){
        this.setState({number : e , error : false})

    }

    handleVerifyBtnClicked = e => {

        if (this.state.number == "" ) {
            // alert("Enter OTP")
            this.setState({ error : true , errorMsg : "Enter OTP" , success : false})
        } else {
            //alert("Call API")
            this.api_ValidateOTP()
        }
    }
    clearOTP = e => {
        this.setState({
        number: '',
        })
        // this.textInput1.focus();
    }

    api_ValidateOTP = e => {
        // console.log("verify state userid")
        // console.log(this.state.user_id)
        
        // console.log("Continue Clicked ...." + otpText)
        axios
            .post('/users/validateOTP', {
                "_id": this.state.user_id,
                "platform": "web",
                "otp": this.state.number,
                "host":localStorage.getItem('host')
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {
                    if (resp.data.error_code === "1010") {
                        // alert(resp.data.msg)
                        this.setState({ error : true , errorMsg : resp.data.msg , success : false})
                    } else if (resp.data.error_code === "1010") {
                        // alert(resp.data.msg)
                        this.setState({ error : true , errorMsg : resp.data.msg , success : false})

                    } else {
                        // alert(resp.data.msg)
                        this.setState({success : true , successMsg : resp.data.msg , error : false })
                    }
                    this.clearOTP()
                } else {
                    // console.log("resp.data.token")
                    // console.log(resp.data.token)
                    localStorage.setItem('token', resp.data.token)
                    this.setState({ isOTPVerified: true })
                }

            }).catch((err)=>{
                console.log(err);
            })

    }
    api_ResendOTP = e => {

        // console.log("Resend Clicked ....user id" + this.state.user_id)
        axios
            .post('/users/resendOTP', {
                "platform": "web",
                "_id": this.state.user_id,
            },
                {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
            .then((resp) => {
                // console.log(resp)
                if (resp.data.data === "error") {
                    if (resp.data.error_code === "1003") {
                        // alert(resp.data.msg)
                        this.setState({error : true , errorMsg : resp.data.msg,success:false })
                    } else {
                        // alert(resp.data.msg)
                        this.setState({error : true , errorMsg : resp.data.msg , success : false})

                    }
                } else {
                    this.setState({success : true , successMsg : "New OTP sent." , error : false})
                    // alert("New otp sent")
                    setTimeout(()=>{
                        this.setState({
                            success : false
                        })
                    },4000)
                    this.clearOTP()
                }

            }).catch((err)=>{
                console.log(err);
            })

    }

    render() {
        if (this.state.isOTPVerified) {
            if (this.state.isComingFrom === "forgotPassword") {
                return <Redirect to="/enter-newpassword" />
            } else {
                return <Redirect to="/set-password" />
            }
        }
        return (
            <MDBCard size="sm" >
                <MDBCardBody >
                    <div className="text-center">
                        <img  src={this.state.logo} className={localStorage.getItem("host") == "visadone" ? "visadone_logo" : "visaero_logo"  +" img-fluid"}></img>
                    </div>
                    <div className="text-left mt-4">
                        <h3><b>Hello !</b></h3>
                    </div>
                    <div className="text-left">
                        <h5>Please enter the 4 digit code sent to your Email</h5>
                    </div>
                    <div className="text-left" style={{ marginTop: '19%' }}>
                        <MDBRow>
                            <MDBCol>
                            <OtpInput
                                        value={this.state.number}
                                        onChange={this.handleOTPChange}
                                        numInputs={4}
                                        containerStyle={{ paddingLeft: "5px", marginTop: "5px" }}
                                        inputStyle={{ border: "none", borderBottom: "1px solid black" , width: "70px" , fontSize : "50px" , marginRight:"px"}}
                                        isInputNum={true}
                                        focusStyle={{ outlineWidth: "0px" }}
                                        className="w-100"
                                            />
                                
                            </MDBCol>

                            {/* <MDBCol><input type="text" id={styles.ipFields} autoComplete="off" pattern="\d*" ref={(input) => { this.textInput1 = input; }}  onChange={this.handletext1Change} /></MDBCol>
                            <MDBCol><input type="text" id={styles.ipFields} autoComplete="off" pattern="\d*" ref={(input) => { this.textInput2 = input; }}  onChange={this.handletext2Change} /></MDBCol>
                            <MDBCol><input type="text" id={styles.ipFields} autoComplete="off" pattern="\d*" ref={(input) => { this.textInput3 = input; }}  onChange={this.handletext3Change} /></MDBCol>
                            <MDBCol><input type="text" id={styles.ipFields} autoComplete="off" pattern="\d*" ref={(input) => { this.textInput4 = input; }}  onChange={this.handletext4Change} /></MDBCol> */}
                        </MDBRow>
                        <div className="text-right mt-2">
                            <a href="#" id={styles.resend} onClick={this.resendOtp} >Resend OTP</a>
                        </div>

                    </div>
                    <div className="mb-2 mt-2">
                        <MDBBtn id={styles.verifyBtn} style={{ backgroundColor: this.state.brand_color }} color="none" onClick={this.handleVerifyBtnClicked}>Verify OTP</MDBBtn>
                    </div>
                    {this.state.success && 
                        <MDBAlert color="success" className="w-75 m-auto text-center">{this.state.successMsg}</MDBAlert>
                    }
                    {this.state.error &&
                        <MDBAlert color="danger" className="w-75 m-auto  text-center">{this.state.errorMsg}</MDBAlert>
                    }
                </MDBCardBody>
            </MDBCard>
        );
    }
};

export default VerifyOtp;